export enum Environment {
  PROD = 'prd',
  MAJSTG = 'majstg',
  DEVMAJ = 'devmaj',
  LOCAL = 'local',
}

export enum Host {
  PROD = 'www.sunrun.com',
  BETA = 'beta.sunrun.com',
  COMPUTE_PROD = 'compute.sunrun.com',
  MAJSTG = 'majstg-www.sunrun.com',
  COMPUTE_MAJSTG = 'majstg-compute.sunrun.com',
  DEVMAJ = 'devmaj-www.sunrundev.com',
  COMPUTE_DEVMAJ = 'devmaj-compute.sunrundev.com',
  PREVIEW_DEVMAJ = 'devmaj-preview.sunrundev.com',
  PREVIEW_PRD = 'preview.sunrun.com',
  LOCAL = 'localhost:3000',
}

export default function getEnv(): Environment {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case Host.PROD:
      case Host.BETA:
      case Host.COMPUTE_PROD:
        return Environment.PROD;
      case Host.MAJSTG:
      case Host.COMPUTE_MAJSTG:
      case Host.PREVIEW_PRD:
        return Environment.MAJSTG;
      case Host.DEVMAJ:
      case Host.COMPUTE_DEVMAJ:
      case Host.PREVIEW_DEVMAJ:
        return Environment.DEVMAJ;
      default:
        return Environment.LOCAL;
    }
  }

  const envName = process?.env?.ENV_NAME;

  if (Object.values(Environment).includes(envName as Environment)) {
    return envName as Environment;
  }

  return Environment.LOCAL;
}
